const CARDS = [
    {
        key: "inquiries",
        label: "Inquiries",
        get: (s) => s?.inquiries_total,
        subGet: (s) =>
            s ? `${s.inquiries_unhandled} unhandled` : "—",
    },
    {
        key: "callbacks",
        label: "Callbacks",
        get: (s) => s?.callbacks_total,
        subGet: (s) =>
            s ? `${s.callbacks_unhandled} unhandled` : "—",
    },
    {
        key: "newsletter",
        label: "Newsletter",
        get: (s) => s?.newsletter_total,
        subGet: () => "subscribers",
    },
    {
        key: "activity",
        label: "Last 24h",
        get: (s) =>
            s ? s.last_24h_inquiries + s.last_24h_callbacks : null,
        subGet: (s) =>
            s
                ? `${s.last_24h_inquiries} inquiry · ${s.last_24h_callbacks} callback`
                : "—",
    },
];

export default function StatsStrip({ stats }) {
    return (
        <div
            className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[rgba(201,168,106,0.15)] border border-[rgba(201,168,106,0.15)]"
            data-testid="admin-stats-strip"
        >
            {CARDS.map((c) => {
                const n = c.get(stats);
                return (
                    <div
                        key={c.key}
                        className="bg-[#0B0B0C] px-5 md:px-7 py-6 md:py-7 flex flex-col justify-between min-h-[110px]"
                        data-testid={`admin-stat-${c.key}`}
                    >
                        <span className="text-[10px] tracking-[0.32em] uppercase text-[#9A958A]">
                            {c.label}
                        </span>
                        <div className="mt-3">
                            <span className="font-serif text-3xl md:text-4xl text-[#F3EFE7] tabular-nums">
                                {n == null ? "—" : n}
                            </span>
                            <p className="text-[11px] tracking-[0.2em] uppercase text-[#C9A86A] mt-1">
                                {c.subGet(stats)}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
